module.exports = __webpack_public_path__ + "764c37efbf6d7ffc176b466fadc6f2ca.png";